export class HashStringUseCase {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute(string, hashingKey) {
        return this.crypto.sodiumCryptoGenericHash(string, hashingKey.key);
    }
}
